<mat-toolbar>
  <span translate>DEVICES</span>
  <span class="toolbar-spacer"></span>
  <button type="button" mat-raised-button color="primary" routerLink="new">
    <span translate>CREATE_NEW_DEVICE</span>
  </button>
</mat-toolbar>
<div class="row mt-3">
  <div class="col-md-12">
    <mat-form-field class="w-100">
      <mat-label translate>SEARCH</mat-label>
      <input type="text" matInput [(ngModel)]="searchText"  (keyup)="applyFilter()">
      @if (searchText) {
        <button mat-icon-button color="primary" matSuffix (click)="$event.stopPropagation();searchText = '';applyFilter();"><mat-icon>close</mat-icon></button>
      }
    </mat-form-field>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    @if (devices) {
      <table  mat-table [dataSource]="dataSource" multiTemplateDataRows class="w-100">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef translate>DEVICE_NAME</th>
          <td mat-cell *matCellDef="let element" class="text-capitalize">
            <mat-icon class="align-bottom">
              {{element == expandedElement ? 'remove_circle_outline' : 'add_circle_outline'}}
            </mat-icon>
            {{element.name}}
          </td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef translate>DEVICE_TYPE</th>
          <td mat-cell *matCellDef="let element" class="text-capitalize">
            {{element.type ? element.type.name : '-' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef translate>STATUS</th>
          <td mat-cell *matCellDef="let element" class="text-capitalize">
            <span class="badge" [ngClass]="{'text-bg-success': element.status === deviceStatuses.installed, 'text-bg-dark': element.status !== deviceStatuses.installed}" translate>{{element.status}}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="target">
          <th mat-header-cell *matHeaderCellDef translate>TARGET</th>
          <td mat-cell *matCellDef="let element" class="text-capitalize"> {{element.target ? element.target : '-'}}</td>
        </ng-container>
        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef translate>COMPANY</th>
          <td mat-cell *matCellDef="let element" class="text-capitalize"> {{element.company ? element.company.name : '-'}}</td>
        </ng-container>
        <ng-container matColumnDef="site">
          <th mat-header-cell *matHeaderCellDef translate>SITE</th>
          <td mat-cell *matCellDef="let element" class="text-capitalize"> {{element.site ? element.site.name : '-'}}</td>
        </ng-container>
        <ng-container matColumnDef="modified">
          <th mat-header-cell *matHeaderCellDef translate>MODIFIED</th>
          <td mat-cell *matCellDef="let element" class="text-capitalize"> {{element.modified}}</td>
        </ng-container>
        <ng-container matColumnDef="modifiedBy">
          <th mat-header-cell *matHeaderCellDef translate>MODIFIEDBY</th>
          <td mat-cell *matCellDef="let element" class="text-capitalize"> {{element.modifiedBy}}</td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="text-capitalize text-end">
            @if (element.company) {
              <button type="button" matTooltip="View in tree" mat-icon-button color="primary" (click)="$event.stopPropagation();" [routerLink]="['/networks', element.company.id]"><mat-icon>account_tree</mat-icon></button>
            }
            <button type="button" matTooltip="Settings" mat-icon-button color="primary" (click)="$event.stopPropagation(); onEditDeviceClick(element)"><mat-icon>settings</mat-icon></button>
          </td>
        </ng-container>
        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
            <div class="overflow-hidden" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              @if (expandedElement && element.id == expandedElement.id) {
                <div>
                  <h2 translate>DEVICE_DETAILS</h2>
                  <h3><span translate>DEVICE_INSTALL_LOCATION</span>: {{element.site && element.site.fulladdress ? element.site.fulladdress : ' - '}}</h3>
                  @if (element.infoList && element.infoList.length) {
                    <table class="table table-sm table-striped">
                      <thead>
                        <tr>
                          <th>Attribute name</th>
                          <th>Attribute value</th>
                          <th>Modified</th>
                          <th>Modified by</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (info of element.infoList; track info) {
                          <tr>
                            <td>{{info.attributeName}}</td>
                            <td>{{info.value}}</td>
                            <td>{{info.modified}}</td>
                            <td>{{info.modifiedBy}}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                  @if (!element.infoList || !element.infoList.length) {
                    <p translate>NO_DEVICE_ATTRIBUTE_YET</p>
                  }
                </div>
              }
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
          class="example-element-row"
          [class.example-expanded-row]="expandedElement === element"
          (click)="onRowClick(element)">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      </table>
    }
    @if (dataSource.data.length === 0) {
      <div class="w-100 p-3 text-center text-muted" translate>NO_DEVICE_FOUND</div>
    }
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>
